import TicketList from '@/pages/ticket/TicketList'
import DokuRedirect from '@/pages/ticket/DokuRedirect'
import TicketOrderHistory from '@/pages/ticket/TicketOrderHistory'
import TicketOrderHistoryDetail from '@/pages/ticket/TicketOrderHistoryDetailWrapper'
import TicketDetail from '@/pages/ticket/TicketDetail'
import TicketFeedbackForm from '@/pages/ticket/FeedbackForm'
import TicketPaymentForm from '@/pages/ticket/PaymentFormWrapper'
import TicketPaymentResult from '@/pages/ticket/PaymentResultWrapper'
import TicketHomePage from '@/pages/ticket/TicketHomePage'
import TicketCart from '@/pages/ticket/TicketCart'
import TicketPaymentFormDev from '@/pages/ticket/TicketPaymentForm'
import TicketCustom from '@/pages/ticket/custom/Home'

const emptyView = {template: '<router-view></router-view>'}

export default [
  {
    path: "ticket",
    component: emptyView,
    name: 'TicketPageBase',
    children: [
      {
        path: 'order-history',
        name: 'TicketOrderHistory',
        component: emptyView,
        children:[
          {
            path: '',
            name: 'TicketOrderHistory',
            component: TicketOrderHistory,
            meta:{
              module_type: 'merchant-ticket'
            }
          },
          {
            path: ':tx_order_id',
            name: 'TicketOrderHistoryDetail',
            component: TicketOrderHistoryDetail,
            meta:{
              module_type: 'merchant-ticket',
              is_special_merchant: true
            }
          },
        ]
      },
      {
        path: 'dev-home',
        name: 'TicketHomePage',
        component: TicketHomePage,
        meta:{
          module_type: 'merchant-ticket-new',
          no_wrapper: true,
          need_reload_merchant: true,
          no_loading: true
        }
      },
      {
        path: 'dev-cart',
        name: 'TicketCart',
        component: TicketCart,
        meta:{
          module_type: 'merchant-ticket-new',
          no_wrapper: true,
          need_reload_merchant: true,
          no_loading: true
        }
      },
      {
        path: 'dev-payment-form/:tx_order_id',
        name: 'TicketPaymentFormDev',
        component: TicketPaymentFormDev,
        meta:{
          module_type: 'merchant-ticket-new',
          no_wrapper: true,
          need_reload_merchant: true,
          no_loading: true
        }
      }
    ]
  },
  {
    path: 'doku/redirect/:tx_order_id',
    name: 'DokuRedirect',
    component: DokuRedirect,
    meta:{
      module_type: 'merchant-ticket'
    }
  },
  {
    path: 'list',
    name: 'TicketListBase',
    component: emptyView,
    children:[
      {
        path: '',
        name: 'TicketList',
        component: TicketList,
        meta:{
          module_type: 'merchant-ticket',
          need_reload_merchant: true
        }
      },
      {
        path: ':ticket_id',
        name: 'TicketDetail',
        component: TicketDetail,
        meta:{
          module_type: 'merchant-ticket'
        }
      }
    ]
  },
  {
    path: 'feedback/:ticket_id',
    name: 'TicketFeedbackForm',
    component: TicketFeedbackForm,
    meta:{
      module_type: 'merchant-ticket'
    }
  },
  {
    path: 'select-payment',
    name: 'TicketSelectPayment',
    component: TicketCustom,
    meta:{
      module_type: 'merchant-general',
      no_wrapper: true,
      need_reload_merchant: true,
      no_loading: true,
      is_special_merchant: true
    }
  },
  {
    path: 'payment/:tx_order_id',
    name: 'TicketPaymentForm',
    component: TicketPaymentForm,
    meta:{
      module_type: 'merchant-ticket',
      is_special_merchant: true
    }
  },
  {
    path: 'payment-success/:tx_order_id',
    name: 'TicketPaymentComplete',
    component: TicketPaymentForm,
    meta:{
      module_type: 'merchant-ticket',
      is_special_merchant: true
    }
  },
  {
    path: 'payment-result/:tx_order_id',
    name: 'TicketPaymentResult',
    component: TicketPaymentResult,
    meta:{
      module_type: 'merchant-ticket',
      is_special_merchant: true
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/modules/merchant/Ticket.js